import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import Beverage from './beverage';

@JsonApiResource({
  type: 'cycle-menu-beverage',
})
export default class CycleMenuBeverage extends BaseEntity {
  @JsonApiProperty({ resolver: Number }) price = 0.0;

  @JsonApiRelationship('beverage') beverage = new Beverage();

  constructor(id?: string, price = 0.0, beverage = new Beverage()) {
    super();
    this.id = id;
    this.price = price;
    this.beverage = beverage;
  }
}
